// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.settings-sidebar[data-v-6a0c544c] {\n  border-right: 1px solid #e0e0e0;\n}\n.settings-content[data-v-6a0c544c] {\n  min-height: 600px;\n}\n.user-avatar[data-v-6a0c544c] {\n  display: inline-block;\n  vertical-align: middle;\n}\n.nav-item-badge[data-v-6a0c544c] {\n  font-size: 0.75rem;\n}\n", ""]);
// Exports
module.exports = exports;
